/* global Swiper */
const venueVenues = () => {
  jQuery(document).ready(function($) {
    const sectionVenueVenues = $('.common-hotel-venue-venues-section');
    if (sectionVenueVenues.length) {
      const tabViewType = sectionVenueVenues.find('.view-type-item');
      const panelViewType = sectionVenueVenues.find('.view-type-content');
      const imagesPanelOpened = sectionVenueVenues.find('#venues-images-view.opened');

      const handleImagesSlider = function() {
        const swiperContainer = sectionVenueVenues.find('.swiper-container');

        if (!swiperContainer.hasClass('swiper-container-initialized')) {
          const prevBtn = sectionVenueVenues.find('.swiper-navigation .prev').get(0);
          const nextBtn = sectionVenueVenues.find('.swiper-navigation .next').get(0);

          new Swiper(swiperContainer.get(0), {
            slidesPerView: 1.5,
            spaceBetween: 16,
            navigation: {
              nextEl: nextBtn,
              prevEl: prevBtn,
            },
            breakpoints: {
              425: {
                slidesPerView: 2,
              },
              768: {
                slidesPerView: 4,
              },
            },
          });
        }
      };

      if (imagesPanelOpened.length) {
        handleImagesSlider();
      }

      if (tabViewType.length) {
        tabViewType.on('click', function(e) {
          e.preventDefault();

          const _this = $(this);
          const target = _this.data('target');

          if ($(target).length) {
            panelViewType.removeClass('opened');
            tabViewType.removeClass('active');
            $(target).addClass('opened');
            _this.addClass('active');

            if (target === '#venues-images-view') {
              handleImagesSlider();
            }
          }
        });
      }
    }
  });
};

export default venueVenues;



// WEBPACK FOOTER //
// ./scripts/routes/modules/venueVenues.js